<template>
  <div class="md-layout">

    <load-overlay v-if="downloading" style="position:absolute;" />

    <md-card class="md-layout-item">
      <md-card-header>
        <h1 class="md-title">Filter</h1>
      </md-card-header>
      <md-card-content>
        <slot />
      </md-card-content>
      <md-card-actions>
        <md-button class="md-raised md-accent" @click="download" :disabled="enableDownload == false">Download</md-button>
      </md-card-actions>
    </md-card>

  </div>
</template>

<script>
  import Api from '@/api';
  import { Events } from '@wsb/wsb-jsbase';
  import LoadOv from '@/components/LoadOverlay';

  const _rv = {
    name: 'Reportview',
    props: {
      url: String,
      ['enable-download']: {
        type: Boolean,
        default: null
      }
    },
    data() {
      return {
        downloading: false
      };
    },
    methods: {
      download() {
        this.downloading = true;
        Api.DownloadFile(this.url, 'Rapport.pdf')
          .then(() => { this.downloading = false; })
          .catch(e => {
            this.downloading = false;
            if (e.indexOf('404') !== -1) {
              Events.RaiseExceptionOccurred("Niets gevonden.");
            } else {
              Events.RaiseExceptionOccurred(e);
            }
          });
      }
    },
    components: {
      'load-overlay': LoadOv
    }
  };

  export default _rv;
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/base/Reportview.vue